export const GET_ADMIN_USERS = 'GET_ADMIN_USERS';
export const GET_ADMIN_USER_DETAILS = 'GET_ADMIN_USER_DETAILS';
export const GET_ADMIN_USER_FORM_BUNDLE = 'GET_ADMIN_USER_FORM_BUNDLE';
export const CREATE_ADMIN_USER = 'CREATE_ADMIN_USER';
export const EDIT_ADMIN_USER = 'EDIT_ADMIN_USER';
export const GET_ADMIN_ROLES = 'GET_ADMIN_ROLES';
export const GET_ADMIN_ROLE_DETAILS = 'GET_ADMIN_ROLE_DETAILS';
export const GET_ADMIN_ROLE_FORM_BUNDLE = 'GET_ADMIN_ROLE_FORM_BUNDLE';
export const CREATE_ADMIN_ROLE = 'CREATE_ADMIN_ROLE';
export const EDIT_ADMIN_ROLE = 'EDIT_ADMIN_ROLE';
export const GET_ADMIN_ARCHETYPES = 'GET_ADMIN_ARCHETYPES';
export const GET_ADMIN_ORGANIZATIONS = 'GET_ADMIN_ORGANIZATIONS';
export const GET_ADMIN_ORGANIZATION_DETAILS = 'GET_ADMIN_ORGANIZATION_DETAILS';
export const GET_ADMIN_ORGANIZATION_FORM_BUNDLE = 'GET_ADMIN_ORGANIZATION_FORM_BUNDLE';
export const CREATE_ADMIN_ORGANIZATION = 'CREATE_ADMIN_ORGANIZATION';
export const EDIT_ADMIN_ORGANIZATION = 'EDIT_ADMIN_ORGANIZATION';
export const GET_ADMIN_ORG_GROUPS = 'GET_ADMIN_ORG_GROUPS';
export const GET_ADMIN_ORG_GROUP_DETAILS = 'GET_ADMIN_ORG_GROUP_DETAILS';
export const CREATE_ADMIN_ORG_GROUP = 'CREATE_ADMIN_ORG_GROUP';
export const EDIT_ADMIN_ORG_GROUP = 'EDIT_ADMIN_ORG_GROUP';
export const GET_ADMIN_ORG_GROUP_ORGANIZATIONS = 'GET_ADMIN_ORG_GROUP_ORGANIZATIONS';
export const ADD_ADMIN_ORG_GROUP_ORGANIZATION = 'ADD_ADMIN_ORG_GROUP_ORGANIZATION';
export const REMOVE_ADMIN_ORG_GROUP_ORGANIZATION = 'REMOVE_ADMIN_ORG_GROUP_ORGANIZATION';
export const SEARCH_ADMIN_USERS = 'SEARCH_ADMIN_USERS';
export const SEARCH_ADMIN_ORGANIZATIONS = 'SEARCH_ADMIN_ORGANIZATIONS';
export const SEARCH_MAINTAINER_CANDIDATES = 'SEARCH_MAINTAINER_CANDIDATES';
